import { FaRegUser } from 'react-icons/fa';
import './DockListCard.sass';
import Card from 'src/hci/common/Card/Card';
import classNames from 'classnames';
import { HiOutlineChip } from 'react-icons/hi';

function DockListCard({ data }) {
  return (
    <Card className="dock-list-card">
      <div className="title-bar">
        <div className={classNames("status", { 'status-online': data.isOnline })}>
          <div className="indicator"></div>
        </div>
        <div className="title">{ data.title || data.manufacturer }</div>
        <div className="serial-number">
          <HiOutlineChip />
          <div className="value">{ data.serialNumber }</div>
        </div>
      </div>
      <div className="register-by">
        <FaRegUser className="icon" />
        <div className="value">{ data.registeredBy?.displayName || data.registeredBy?.emailAddress }</div>
      </div>
      <div className="register-time">{ data.creationDate }</div>
    </Card>
  )
}

export default DockListCard